import mixitup from '../../Assets/MixItUp';
import bubble from '../Component/Stopper';

function removeElement(element) {
    element.parentNode.removeChild(element);
}

function replaceNode(settings) {
    settings.old.parentNode.replaceChild(settings.new, settings.old);
}

(function () {
    let containerEl = document.querySelector('.persons-entries');
    if (containerEl) {
        let mixer = mixitup(containerEl, {
            animation: {
                animateResizeContainer: true,
            },
            multifilter: {
                enable: true,
            },
        });
    }

    let teasers = document.querySelectorAll('.persons-collection');

    // We do this manipulation only if we are live…
    if (teasers.length && _gg.isLive) {
        // We have some random teasers with evtl. multiple persons.
        let length = parseInt(teasers[0].getAttribute('data-length'));
        let array = [];
        for (let i = 0; i < length; i++) {
            array.push(i);
        }
        // Shuffle the array
        array.sort(() => 0.5 - Math.random());

        for (let index = 0; index < teasers.length; index++) {
            let teaser = teasers[index];
            let stopper = teaser.querySelector('.stopper');
            let selector = array.pop(); // pop() is faster than shift()
            if (typeof selector == 'number') {
                let newNode = teaser.childNodes[selector];
                if (stopper) {
                    newNode.appendChild(stopper);
                }
                replaceNode({
                    old: teaser,
                    new: newNode,
                });
            } else {
                // We have shown all people, so we delete the element
                removeElement(teaser);
            }
        }
        // Recalculate the person bubble
        bubble('person-teaser.-stopper stopper');
    }
})();
